import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPodador, getColorEstado, dataTable } from "./handlers";
import { Card, Container, Table } from "../../../components";
import { Badge } from "react-bootstrap";
import UpdatePodador from "./form/form-update";
import CambiarEstado from "./form/cambiar-estado";
import CrearObservacion from "./form/crear-observacion";
import EliminarObservacion from "./form/eliminar-observacion";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserWrapper";
import { useContext } from "react";

export default function Podador() {
  const { id } = useParams();
  const { actions: ua } = useContext(UserContext);
  const nav = useNavigate();

  const [podador, setPodador] = useState({
    data: null,
    error: null,
    params: null,
    loading: false,
  });

  const [observaciones, setObservaciones] = useState([]);

  const [rtaEdit, setRtaEdit] = useState({
    data: null,
    error: null,
    params: null,
    loading: false,
  });

  const [state, setState] = useState(null);

  const [open, setOpen] = useState(false);
  const [openObs, setOpenObs] = useState(false);
  const [destroyObs, setDestroyObs] = useState(false);

  const [destroy, setDestroy] = useState(null);

  useEffect(() => {
    if (ua.hasRole("admin.app")) {
      getPodador(podador, setPodador, id);
    } else {
      nav("/");
    }
  }, []);

  useEffect(() => {
    if (podador.data != null && podador.error == null) {
      setState(podador.data.estado);
      setObservaciones(podador.data.observaciones);
    }
  }, [podador]);

  console.log(podador);

  return (
    <Container linkBack={"/podadores"} titulo={"Información del Podador"}>
      {podador.loading && (
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}
      {podador.data && state && (
        <div>
          <Card
            title={() => {
              return (
                <div className="d-flex justify-content-between">
                  <span>Datos del Podador</span>
                  <button
                    type="button"
                    onClick={() => setOpen(true)}
                    className={`btn btn-sm ${getColorEstado(state.id)}`}
                  >
                    {state.estado}
                  </button>
                  <CambiarEstado
                    estado={podador.data.estado}
                    id={podador.data.id}
                    open={open}
                    setOpen={setOpen}
                    state={setState}
                  />
                </div>
              );
            }}
          >
            {podador.data && (
              <UpdatePodador rta={rtaEdit} setRta={setRtaEdit} data={podador.data} />
            )}
          </Card>
          {console.log(podador.loading)}
          {podador?.data?.credencial && !rtaEdit.loading && (
            <object
              data={podador?.data?.credencial}
              type="application/pdf"
              className="w-100"
              style={{ aspectRatio: "3/4" }}
            />
          )}

          {/* <Card
            title={() => {
              return (
                <div className="d-flex justify-content-between">
                  <span>Observaciones del Podador</span>
                  <button
                    type="button"
                    disabled={state.id == 2}
                    onClick={() => setOpenObs(true)}
                    className="btn btn-sm btn-primary"
                  >
                    Crear Observación
                  </button>
                  <CrearObservacion
                    setObservaciones={setObservaciones}
                    observaciones={observaciones}
                    open={openObs}
                    setOpen={setOpenObs}
                    podador_id={podador.data.id}
                    state={setState}
                  />
                </div>
              );
            }}
          >
            <Table
              data={dataTable(observaciones, state, destroyObs, setDestroyObs, setDestroy)}
              search={true}
            />
            <EliminarObservacion
              open={destroyObs}
              setOpen={setDestroyObs}
              destroy={destroy}
              estado={podador.data.estado}
              state={setState}
              setObservaciones={setObservaciones}
              observaciones={observaciones}
            />
          </Card> */}
        </div>
      )}
    </Container>
  );
}
